import "./style.scss";
import CompletedIcon from "./img/completed.svg?react";
import InfoIcon from "./img/info.svg?react";
import DOMPurify from "dompurify";
export default function BadgeCard({
  image,
  points,
  completed = false,
  title,
  surprise = false,
}) {
  const hidden = surprise && !completed;
  return (
    <div
      className={`badge-card-component ${completed ? "completed" : ""} ${
        hidden ? "hidden" : ""
      }`}
    >
      <div className="badge-card">
        <div className="top">
          {title && (
            <h3
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(hidden ? "Überraschung" : title),
              }}
              className="card-title"
            />
          )}

          <div className="image">
            <img src={image} alt="Badge" />
          </div>
        </div>
        <div className="bottom">
          {/* <div className="btn">
            <span className="btn-content">{points} Punkte</span>
          </div> */}
          <div className="btn">
            <span className="btn-content">
              {hidden && (
                <span>
                  <strong>?</strong> Punkte
                </span>
              )}
              {!hidden && (
                <span className="points-content">
                  <span className="points">{points}</span> Punkte
                </span>
              )}

              <span className="icon">
                {completed ? <InfoIcon /> : <InfoIcon />}
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
